define('app-console/lib/console',['require','exports','module'],function(require,exports,module){
	var stubApi='log,dir,dirxml,info,warn,debug,error,assert,trace'.split(','),
		_noop=function(){},
		UNDEFINED 		= "undefined",
		konsole;

		//Build a stand-in console if missing
	if(typeof window!==UNDEFINED){
		if(!window.console){
	        window.console={
	        	isNative : false
	        };
	    }
	    stubApi.forEach(function(meth){
	        window.console[meth]=window.console[meth]||window.console.log||_noop;
	    });
	 
	}
	
   konsole = console || window && window.console || {};
   konsole.trueConsole = !!konsole.group && !!konsole.log.apply && !konsole.msIsIndependentlyComposed;

	return konsole;

});

